import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, X, Loader2 } from "lucide-react";
import api, { imgSrc } from "../../lib/api";
import { errMsg } from "./ui";

const TYPES = ["image/jpeg", "image/png", "image/webp"];

export default function ImageUpload({ value, onChange, testPrefix, label = "Foto" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files[0];
    e.target.value = "";
    if (!f) return;
    if (!TYPES.includes(f.type)) { toast.error("Format harus JPG, PNG, atau WEBP"); return; }
    if (f.size > 5 * 1024 * 1024) { toast.error("Ukuran maksimal 5MB"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/uploads/image", fd);
      onChange(r.data.url);
      toast.success("Foto diunggah");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div>
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">{label}</span>
      <div className="mt-2 flex items-center gap-3">
        <button type="button" data-testid={`${testPrefix}-image-btn`} onClick={() => ref.current?.click()} disabled={busy}
          className="relative w-24 h-24 shrink-0 rounded-sm border border-dashed border-[#35353B] hover:border-[#D4AF37] bg-[#191A1F] overflow-hidden flex items-center justify-center transition-colors">
          {busy ? <Loader2 className="animate-spin text-[#D4AF37]" size={20} />
            : value ? <img data-testid={`${testPrefix}-image-preview`} src={imgSrc(value)} alt="" className="w-full h-full object-cover" />
            : <ImagePlus className="text-[#A8A8AD]" size={22} />}
        </button>
        <div className="text-xs text-[#A8A8AD] space-y-2">
          <div>JPG, PNG, WEBP · maks 5MB</div>
          {value && (
            <button type="button" data-testid={`${testPrefix}-image-remove-btn`} onClick={() => onChange(null)}
              className="flex items-center gap-1 text-[#F06464] hover:underline"><X size={12} /> Hapus foto</button>
          )}
        </div>
        <input ref={ref} data-testid={`${testPrefix}-image-input`} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} />
      </div>
    </div>
  );
}
